const IDPStrategies = {
  /**
   * Handles the redirect URL for OpenID Connect (OIDC) authentication.
   * @param {string} IDPRedirectUrl - The redirect URL from the Identity Provider.
   * @param {Object} state - The state object containing information about the authentication request.
   * @param {string} productDomain - The domain of the product initiating the authentication.
   * @returns {string} The updated redirect URL with the necessary parameters.
   */
  oidc: (IDPRedirectUrl, state, productDomain) => {
    const url = new URL(IDPRedirectUrl);
    const productId = url.searchParams.get('state') || '';
    const meta = {
      // This redirect URL is used to redirect the user back to the product after successful authentication
      redirectURL:
        state !== null && state.redirect && state.redirect !== 'null'
          ? state.redirect
          : productDomain,
      isFromIDP: true,
      type: 'oidc',
      productId,
    };
    url.searchParams.set('state', encodeURIComponent(JSON.stringify(meta)));
    return url.toString();
  },

  /**
   * Handles the redirect URL for SAML authentication.
   * @param {string} IDPRedirectUrl - The redirect URL from the Identity Provider.
   * @param {Object} state - The state object containing information about the authentication request.
   * @param {string} productDomain - The domain of the product initiating the authentication.
   * @returns {string} The updated redirect URL with the necessary parameters.
   */
  saml: (IDPRedirectUrl, state, productDomain) => {
    const url = new URL(IDPRedirectUrl);
    const relayStateParam = url.searchParams.get('RelayState');
    let relayObj = {};
    if (relayStateParam) {
      try {
        relayObj = JSON.parse(relayStateParam);
      } catch {
        relayObj = {};
      }
    }
    const meta = {
      // This redirect URL is used to redirect the user back to the product after successful authentication
      redirectURL:
        state !== null && state.redirect && state.redirect !== 'null'
          ? state.redirect
          : productDomain,
      isFromIDP: true,
      type: 'saml',
      productId: relayObj.product_id || '',
      ...relayObj,
    };
    url.searchParams.set('RelayState', JSON.stringify(meta));
    return url.toString();
  },

  // add more handlers here as needed
};

export default IDPStrategies;
